

import {
  classes,
  cssClass
} from '../../style';
import { PermissionsGridStyles } from './PermissionsGridStyle';

export namespace PermissionsDialogStyles {
  const PermissionsDialogCssPrefix = 'PermissionsDialog';

  export const lineHeight = 18;
  export const titleMarginBottom = 18;
  export const titleMarginTop = 30;
  export const tabsHeight = 36;
  export const tabsBottomHeight = 3;
  export const tabsMarginBottom = 20;
  export const searchMarginTop = 18;
  export const searchMarginBottom = 12;
  export const containerPadding = 18;
  export const gridContainerWidth = PermissionsGridStyles.GranteeCellWidth + PermissionsGridStyles.RoleCellTotalWidth + PermissionsGridStyles.capabilityCellWidth();
  export const dialogContainerWidth = gridContainerWidth + 2 * containerPadding;
  export const TITLE_HEADER_CLASSNAME: string = 'permissions-title-header';

  export const DialogContents = cssClass(PermissionsDialogCssPrefix, 'contents', {
    overflowX: 'inherit',
    lineHeight: `${lineHeight}px`,
    paddingRight: `${containerPadding}px`,
  });

  const TitleHeaderContainer = cssClass(PermissionsDialogCssPrefix, 'title-header-container', {
    clear: 'both', // needed because floating elements are above the title
    paddingTop: `${titleMarginTop}px`,
    fontWeight: 'bold',
  });

  const TitleHeaderContainerTopComponent = cssClass(PermissionsDialogCssPrefix, 'title-header-container-top', {
    paddingTop: '0px',
    fontWeight: 'bold',
  });

  export const TitleHeaderClass = classes(TITLE_HEADER_CLASSNAME, TitleHeaderContainer);
  export const TitleHeaderClassDisabled = classes(TITLE_HEADER_CLASSNAME, TitleHeaderContainer, PermissionsGridStyles.DisabledTextStyle);
  export const TitleHeaderClassTop = classes(TITLE_HEADER_CLASSNAME, TitleHeaderContainerTopComponent);
  export const TitleHeaderClassTopDisabled = classes(TITLE_HEADER_CLASSNAME, TitleHeaderContainerTopComponent, PermissionsGridStyles.DisabledTextStyle);



  export const SearchTextboxContainer = cssClass(PermissionsDialogCssPrefix, 'search-textbox-container', {
    marginBottom: `${searchMarginBottom}px`,
    marginTop: `${searchMarginTop}px`,
    $nest: {
      'input': {
        width: '480px',
      },
    },
  });

  export const HelpLink = cssClass(PermissionsDialogCssPrefix, 'help-link', {
    float: 'right',
  });

  export const DatabaseUnAssignedMessage = cssClass(PermissionsDialogCssPrefix, 'database-unassigned', {
    marginTop: '5px',
    float: 'left',
    clear: 'left',
    lineHeight: `${lineHeight}px`
  });
}
